import React from "react"

interface AppModalCardProps {
  children: React.ReactNode
  title?: string
  className?: string
  panelClassName?: string
  size?: "sm" | "md" | "lg" | "xl"
  mobileSheet?: boolean
}

const SIZE_CLASSNAME: Record<NonNullable<AppModalCardProps["size"]>, string> = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
}

const AppModalCard: React.FC<AppModalCardProps> = ({
  children,
  title,
  className = "",
  panelClassName = "",
  size = "sm",
  mobileSheet = false,
}) => {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      className={`w-full bg-white shadow-xl ${mobileSheet ? `max-h-[90dvh] overflow-y-auto rounded-t-3xl sm:rounded-3xl sm:${SIZE_CLASSNAME[size]}` : `${SIZE_CLASSNAME[size]} rounded-3xl`} ${panelClassName} ${className}`.trim()}
    >
      {children}
    </div>
  )
}

export default AppModalCard